// i18n area 'backups' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.lt-LT.meta.json.
import type { enUS } from './backups'

export const ltLT: typeof enUS = {
  ckpt: {
    contents: 'Priima',
    contentsHint:
      'Kas čia gali nusileisti. „Checkpointai“ yra klasterio konfigūracija, „Duomenų kopijos“ yra virtualių mašinų kopijos: du skaitymai susideda, viena paskirties vieta gali priimti abu.',
    content: { checkpoints: 'Checkpointai', backups: 'Duomenų kopijos' },
    destinationsTitle: 'Atsarginių kopijų paskirties vietos',
    checkpointsTitle: 'Checkpoint',
    restoreTitle: 'Atkūrimas',
    addDestination: 'Pridėti paskirties vietą',
    addDestinationTitle: 'Pridėti atsarginių kopijų paskirties vietą',
    editDestinationTitle: 'Redaguoti paskirties vietą',
    storage: 'Storage',
    storageHint: 'Dir tipo storage (dir/NFS/CIFS/CephFS) — artefaktai yra įprasti failai platformos vardų srityje.',
    schedule: 'Tvarkaraštis',
    scheduleNone: 'Tik rankiniu būdu',
    scheduleHourly: 'Kas valandą',
    scheduleDaily: 'Kasdien',
    scheduleWeekly: 'Kas savaitę',
    scheduleHour: 'Valanda',
    scheduleWeekday: 'Diena',
    scheduleHint:
      'Prie suplanuotų checkpoint nebūna operatoriaus, kuris įvestų masterpass: keystore paslaptys supakuojamos kaip placeholder.',
    retention: 'Retention',
    retentionHint:
      'Kiek suplanuotų checkpoint laikyti — sweeper pašalina senesnius, viršijančius šį skaičių. Rankiniai ir prieš atkūrimą daromi checkpoint nešalinami niekada.',
    paused: 'Pristabdyta',
    pausedHint:
      'Operatoriaus blackout: kol pauzė tęsiasi, šioje paskirties vietoje niekas neplanuojama ir niekas negenima — tiek duomenų politikos, tiek checkpoint. Vykstantys vykdymai niekada neliečiami.',
    orphanRuns: '{n} našlaičiai vykdymai',
    orphanRunsHint:
      'Suplanuoti vykdymai iš policy, kurių šioje paskirtyje nebėra: jokia retention jų nevaldo — niekada neskaičiuojami, niekada negenimi — ir ištrina juos tik ranka. tvirt diagnose lęšis „backups“ įvardija pašalintas policy.',
    rescan: 'Iš naujo priimti artefaktus',
    rescanTitle: '{name} artefaktų pakartotinis priėmimas',
    rescanHint:
      'Atkuria atsarginių kopijų katalogą (VM/CT/App) iš paskirties vietoje esančių artefaktų manifestų. Esamos eilutės niekada neliečiamos; nežinomų politikų kopijos lieka našlaitės (niekada negenimos automatiškai). Žingsnis po bootstrap atkūrimo.',
    masterpassDrWarning:
      'Katastrofos scenarijus: LUKS diskai grįžta TIK iš checkpoint SU masterpass. Suplanuoti checkpoint pakuoja vietaženklius — periodiškai darykite rankinį checkpoint su masterpass.',
    policy: {
      title: 'Duomenų backup politikos',
      hint: 'Vardinės politikos: kokie objektai (kind, žymos, scope), kaip dažnai, kada vykdymas gali prasidėti ir kiek kopijų laikyti. Įtraukimo gestas lieka objekto savininkui: žymos priskiriamos jo paties scope.',
      add: 'Pridėti politiką',
      column: 'Duomenų politikos',
      name: 'Pavadinimas',
      nameHint:
        'Policy etiketė, unikali paskirties viduje. Vykdymai seka stabilų policy id: pervadinti nemokama; ištrynus jos vykdymai lieka našlaičiai (nebeskaičiuojami ir nebegenimi).',
      kindLocked: 'Esamos policy objektų šeimos keisti negalima: sukurkite naują policy.',
      kindLabel: 'Objektai',
      kind: { vm: 'Virtualiosios mašinos', ct: 'Konteineriai', app: 'Programos' },
      tags: 'Žymų parinkiklis',
      tagsHint:
        'Poros tag=reikšmė, atskirtos kableliais, jungiamos AND. Tuščios žymos ir scope nepasirenka nieko — niekada „visko“.',
      scopes: 'Scope',
      scopesHint: 'Scope keliai (pomedžiai), atskirti kableliais, tarpusavyje jungiami OR.',
      windowStart: 'Langas nuo',
      windowEnd: 'Langas iki',
      windowHint:
        'Vykdymo langas (HH:MM, vietos laikas; pradžia už pabaigos peržengia vidurnaktį). Jis valdo tik STARTĄ: vykdymas, kuris jį viršija, niekada nenužudomas.',
      mode: 'Režimas',
      modeHint: 'Inkrementinis joja ant serijų šeimos; nutrūkusi serija degraduoja į full, pasakyta žurnale.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementinis',
      requireQuiesce: 'Reikalauti quiesce (guest agent)',
      paused: 'Politika pristabdyta',
      retentionNone: 'Laikyti viską',
      retentionCount: 'Skaičius',
      retentionGfs: 'GFS žiedai',
      gfs: {
        keepLast: 'Paskutinės',
        daily: 'Kasdienės',
        weekly: 'Savaitinės',
        monthly: 'Mėnesinės',
        yearly: 'Metinės'
      },
      gfsHint:
        'Kiekvienam žiedui laikoma naujausia kiekvieno iš paskutinių N laikotarpių kopija. Laikoma kopija išlaiko gyvą visą savo grandinę — niekada bazės su našlaičiais.',
      lastRun: 'Paskutinis vykdymas',
      neverRan: 'niekada nevykdyta'
    },
    lastCheckpoint: 'Paskutinis checkpoint',
    neverRun: 'Niekada nesukurta',
    createNow: 'Sukurti checkpoint',
    createNowTitle: 'Sukurti checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Apsaugo slaptas keystore reikšmes (argon2id → AES-256-GCM, kiekvienai reikšmei atskirai). Ji niekada neįrašoma: išsaugokite ją — be jos atkūrimas vietoj tikrų paslapčių pateiks placeholder.',
    masterpassEmptyHint: 'Palikite tuščią, kad vietoj paslapčių būtų supakuoti aiškūs placeholder.',
    createStarted: 'Kuriamas checkpoint…',
    destinationInUseError: "'{name}' vis dar turi checkpoint — pirma juos ištrinkite.",
    origin: 'Kilmė',
    originManual: 'rankinis',
    originSchedule: 'suplanuotas',
    originPreRestore: 'prieš atkūrimą',
    originPreChange: 'prieš pakeitimą',
    preChangeRetention: 'Checkpointai prieš pakeitimą',
    preChangeRetentionHint:
      'Tuščia = išjungta. Pirmas konfigūracijos įrašas po ramybės laikotarpio čia užfiksuoja ankstesnę būseną (kilmė „prieš pakeitimą“); naujausi saugomi iki skaičiaus — sava, genima retencija.',
    diffTitle: 'Pakeitimų peržiūra',
    diffFailed: 'Peržiūra nepavyko',
    diffRetry: 'Bandyti dar kartą',
    diffCounts: '{changed} keisis · {missing} bus sukurta · {extra} perteklinių · {equal} identiškų',
    diffChanged: 'keičiasi',
    diffMissing: 'būtų sukurtas',
    diffExtra: 'būtų ištrintas',
    diffJsonb: 'jsonb nuorodų negalima patikrinti prieš taikymą',
    diffSecret: 'užantspauduoti laukai, nepalyginami',
    diffMore: 'dar {n}…',
    diffNeeded: 'Paleidimas aktyvuojasi, kai peržiūra atspindi pasirinkimą.',
    phase: 'Būsena',
    phaseRunning: 'vykdomas',
    phaseComplete: 'baigtas',
    phaseError: 'klaida',
    secrets: 'Paslaptys',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholder',
    size: 'Dydis',
    created: 'Sukurta',
    destination: 'Paskirtis',
    download: 'Atsisiųsti .tvbk',
    deleteCheckpoint: 'Ištrinti checkpoint',
    noCheckpoints: 'Checkpoint nėra — sukurkite jį iš kurios nors paskirties vietos.',

    // Round #156 (standartinis dialogas): visas backup įrašo skaitymo paviršius
    // — detalių eilutės laukams, kurie lentelėje niekada nerodomi.
    families: 'Šeimos',
    generation: 'Karta',
    completedAt: 'Baigta',
    errorDetail: 'Klaidos detalės',
    manifest: 'Manifest',
    restoreHint:
      'Įkelkite .tvbk artefaktą: turinio naršyklė parodo, kas jame yra, tada pasirinkite, ką ir kaip atkurti.',
    uploadFile: 'Įkelti .tvbk failą',
    uploading: 'Įkeliama…',
    uploadFailed: 'Nepavyko atverti artefakto',
    explorerTitle: 'Checkpoint turinys',
    checkpointFrom: 'Klasterio {cluster} checkpoint, sukurtas {when} ({origin}, karta {generation})',
    otherCluster:
      'Šis checkpoint yra iš KITO klasterio ({cluster}) — atkūrimas tarp klasterių atkeliaus būsimame etape.',
    encrypted: 'užšifruota',
    objectsCount: 'objektų: {n}',
    mode: 'Režimas',
    modeMerge: 'Merge — suderina: pažymėtieji įrašomi (upsert), niekas nešalinama',
    modeOverwrite:
      'Overwrite — laimi checkpoint: ištisai pažymėta šeima pakeičiama visa (dabartinės eilutės, kurių checkpoint nėra, dingsta)',
    restoreMasterpassHint:
      'Masterpass, su kuria buvo sukurtas checkpoint. Be jos užšifruotos paslaptys atkuriamos kaip aiškūs placeholder.',
    checkMasterpass: 'Patikrinti',
    masterpassOk: 'Masterpass teisinga',
    masterpassWrong: 'Masterpass neteisinga',
    parachuteDestination: 'Parašiuto paskirties vieta',
    parachuteHint: 'Prieš paliesdamas bet kurią eilutę, task čia sukuria automatinį checkpoint prieš atkūrimą.',
    summaryTitle: 'Kas nutiks',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'visa šeima',
    summaryObjects: 'pažymėtų objektų: {n}',
    confirmHint:
      'Įveskite klasterio pavadinimą ({name}), kad patvirtintumėte — atkūrimas perrašo deklaruotą konfigūraciją.',
    confirmField: 'Klasterio pavadinimas',
    startRestore: 'Atkurti',
    restoreRunning: 'Vykdomas atkūrimas…',
    restoreDone: 'Atkūrimas baigtas — reconcileriai konverguoja į naują deklaraciją.',
    restoreFailed: 'Atkurti nepavyko',
    discard: 'Atsisakyti',
    selectionEmpty: 'Pasirinkite bent vieną šeimą arba objektą.'
  },

  backup: {
    intro: {
      title: 'VM ir konteinerių duomenų backup',
      subtitle: 'Blokeliai, kuriais naudojasi išorinė backup programinė įranga',
      whatItIs:
        'TVirt pateikia keturis primityvus: quiesced snapshot, change tracking kiekvienam diskui, tik skaitomą NBD eksportą ir konfigūracijos eksportą. Juos valdo Veeam, Bacula, Acronis ir panašūs.',
      whatItIsNot:
        'TVirt nėra backup produktas: jis nieko neplanuoja, netaiko jokios retention politikos ir nesaugo jokio jūsų duomenų archyvo. Retention, katalogai ir atkūrimo politikos lieka programinei įrangai, kurią jau naudojate.'
    },
    cbt: {
      title: 'Pakeitimų sekimas',
      colVm: 'VM',
      colDisk: 'Diskas',
      colState: 'Būsena',
      colBitmaps: 'Bitmapai',
      colObservedAt: 'Stebėta',
      colChangeId: 'Change ID',
      colMechanic: 'Mechanizmas',
      stateActive: 'Aktyvus',
      stateInactive: 'Išjungtas',
      stateInconsistent: 'Nenuoseklus — kita kopija turi būti pilna',
      stateBroken: 'Grandinė nutrūko — išjunkite, tada įjunkite kaip naują grandinę',
      stateSnapshots: 'Visada įjungtas — delta tarp momentinių kopijų',
      stateUnavailable: 'Šiame diske nepasiekiamas',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitmapas',
        'rbd-snapdiff': 'Ceph momentinių kopijų diff',
        'lvm-thin-delta': 'Thin pool delta',
        none: 'Nėra'
      },
      empty:
        'VM diskų nėra. Sekimas skaitomas pagal diską: įjunkite jį qcow2 diske arba darykite momentines kopijas rbd/SAN.',
      chainBroken: 'Grandinė nutrūko',
      chainBrokenText:
        'Nutraukė {reason}: {bitmaps}. Išjunkite bitmapą (grandinė prarasta, kita kopija pilna), tada įjunkite jį kaip naują grandinę.',
      lineages: 'Epochos',
      epochFrozen: 'užšaldyta momentinėje kopijoje {snapshot}',
      epochLost: 'prarasta ({cause})',
      epochRecording: 'įrašo galvoje',
      milestones: 'Gairės (momentinės kopijos)',
      enable: 'Įjungti sekimą',
      disable: 'Išjungti',
      reset: 'Atstatyti',
      changedAreas: 'Pakeistos sritys',
      denied: 'Neturite leidimo šioje VM',
      enableTitle: 'Įjungti pakeitimų sekimą',
      disableTitle: 'Išjungti pakeitimų sekimą',
      resetTitle: 'Atstatyti bitmapą',
      areasTitle: 'Pakeistos sritys',
      bitmapName: 'Bitmapo pavadinimas',
      bitmapNameHint: 'Savas pavadinimas: tvirt- ir tvbk- priklauso platformai',
      granularity: 'Granuliarumas (baitai)',
      granularityHint: 'Dvejeto laipsnis; numatytasis 65536',
      bitmap: 'Bitmapas',
      disableHint: 'Pašalina bitmapą ir visą jo epochų istoriją: kita kopija turi būti pilna.',
      resetHint: 'Ištuština bitmapą — naujas pagrindas: change ID, senesnis už atstatymą, nebesudedamas.',
      areasFrom: 'Nuo momentinės kopijos',
      areasTo: 'Iki momentinės kopijos',
      areasRun: 'Apskaičiuoti',
      areasResult: '{count} pakeistų sričių, {bytes}',
      areasEmpty: 'Tarp dviejų momentinių kopijų nėra pakeistų sričių',
      areasZero: 'nuliai',
      areasMore: 'rodomos pirmos {shown} iš {count}',
      submit: 'Patvirtinti',
      error: 'Sekimo veiksmas nepavyko'
    },
    exports: {
      title: 'Atviri NBD eksportai',
      colVm: 'VM',
      colDisk: 'Diskas',
      colSnapshot: 'Momentinė kopija',
      colBitmap: 'Bitmapas',
      colPhase: 'Fazė',
      colNode: 'Mazgas',
      colEndpoint: 'Galinis taškas',
      colExpires: 'Baigiasi',
      colCreated: 'Atidarytas',
      colError: 'Klaida',
      phase: {
        preparing: 'Ruošiama',
        ready: 'Paruoštas',
        closed: 'Uždarytas',
        error: 'Nepavyko'
      },
      expiresIn: 'po {minutes} min',
      expired: 'pasibaigęs',
      empty: 'Eksportų nėra. Skaitymo sesija pateikia vieną diską vienoje momentinėje kopijoje NBD klientui; rašymo sesija užpildo sustabdytos VM nepaliestą diską. Abi miršta pasibaigus galiojimui.',
      endpointHint: 'TLS su klasterio CA; eksporto pavadinimas yra bilietas — jis miršta kartu su sesija',
      closeDenied: 'Neturite leidimo uždaryti šios VM eksportų',
      open: 'Atidaryti NBD eksportą',
      openTitle: 'Atidaryti NBD eksportą',
      openDisk: 'Diskas',
      openBitmap: 'Bitmapas (neprivaloma)',
      openBitmapHint:
        'Paskelbia šio bitmapo šioje momentinėje kopijoje užšaldytą epochą kaip pakeistų extentų meta-context (tik qcow2 diskai)',
      openTtl: 'Galiojimo laikas (minutės)',
      openSubmit: 'Atidaryti',
      openError: 'Eksporto atidaryti nepavyko',
      colMode: 'Režimas',
      mode: {
        read: 'Skaitymas',
        write: 'Rašymas'
      },
      caCertificate: 'Klasterio CA',
      caCopy: 'Kopijuoti PEM',
      caDownload: 'Atsisiųsti ca-cert.pem',
      caHint: 'Įrašykite PEM į ca-cert.pem privačiame kataloge ir junkitės per nbds://…?tls-certificates=<katalogas> (nbdcopy, nbdinfo) arba --object tls-creds-x509,dir=<katalogas>,endpoint=client (qemu-img)',
      caAbsent: 'Sesija neneša CA (nėra PKI)',
      openWrite: 'Atverti rašymo eksportą',
      openWriteTitle: 'Atverti rašymo eksportą',
      openWriteIntro: 'Diskas turi būti nepaliestas: gimęs tuščias, niekada nerašytas, be momentinės kopijos; VM sustabdyta. Atkūrimas UŽPILDO diską, o ne jį taiso. Kol sesija atvira, VM nepasileidžia, nedaro momentinės kopijos, nesiklonuoja, o diskas neperkeliamas.',
      openWriteSubmit: 'Atverti',
      openWriteError: 'Rašymo eksporto nepavyko atverti',
      openWriteDenied: 'Trūksta vm.restore.data šiai VM',
      openWriteStopped: 'Sustabdykite VM, kad atvertumėte rašymo eksportą',
      fromDescription: 'Sukurti VM iš aprašo',
      fromDescriptionTitle: 'Sukurti VM iš aprašo',
      fromDescriptionIntro: 'export-vm-meta aprašas grįžta kaip sustabdyta VM su tuščiais aprašytos geometrijos diskais — paruošta rašymo eksportams, diskas po disko. Baitai čia nekeliauja: juos neša restore-disk (CLI) arba atsarginių kopijų produkto NBD klientas.',
      fromDescriptionDoc: 'Aprašas (JSON)',
      fromDescriptionDocHint: 'Įklijuokite export-vm-meta dokumentą arba pasirinkite failą',
      fromDescriptionFile: 'Pasirinkti failą…',
      fromDescriptionInvalid: 'Tekstas nėra JSON dokumentas',
      fromDescriptionName: 'Naujos VM pavadinimas',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Jūsų pradinis scope',
      fromDescriptionStorage: 'Diskų saugykla',
      fromDescriptionStorageHint: 'Kiekvienas diskas gimsta čia, numatytuoju saugyklos formatu',
      fromDescriptionMetadataStorage: 'Metaduomenų saugykla',
      fromDescriptionSameAsStorage: 'Ta pati kaip diskų',
      fromDescriptionBridge: 'Tiltas',
      fromDescriptionBridgeHint: 'Be tilto ar tinklo VM gimsta be tinklo plokščių',
      fromDescriptionNetwork: 'Loginis tinklas (fabric/tinklas)',
      fromDescriptionSubmit: 'Sukurti',
      fromDescriptionError: 'VM nepavyko sukurti',
      fromDescriptionDone: 'VM sukurta: {name}',
      fromDescriptionOpen: 'Atverti VM',
      fromDescriptionDenied: 'Trūksta vm.create',
      fromDescriptionStillRunning: 'Kūrimas vis dar vyksta: laukiame toliau'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'VM duomenų atsarginės kopijos',
      titleOnVm: 'Duomenų atsarginės kopijos',
      empty:
        'Kopijų nėra. Kopija perkelia diskus, UEFI varstore ir vTPM būseną į paskirties vietą ir pergyvena virtualią mašiną.',
      colVm: 'VM',
      colCreated: 'Padaryta',
      colPhase: 'Baigtis',
      colDestination: 'Paskirties vieta',
      colContains: 'Turinys',
      colSize: 'Dydis',
      colOrigin: 'Kilmė',
      colMode: 'Tipas',
      retentionChip: 'Saugojimas',
      retentionHint:
        'Paskirties vietos saugojimo taisyklė gali ištrinti šią kopiją neklaususi: ji gimė iš tvarkaraščio. Rankinės kopijos niekada nešluojamos.',
      policyRemoved: 'Policy pašalinta: {name}',
      policyRemovedHint:
        'Šį backup suplanavusi policy nebeegzistuoja: jokia retention jo nevaldo (niekada negenimas automatiškai) — ištrinkite jį rankiniu būdu, kai jo nebereikės.',
      phase: {
        running: 'Vykdoma',
        complete: 'Baigta',
        error: 'Nepavyko'
      },
      origin: {
        manual: 'Rankinė',
        schedule: 'Suplanuota'
      },
      mode: {
        full: 'Pilna',
        incremental: 'Prieauginė'
      },
      contains: {
        disks: 'Diskai',
        varstore: 'UEFI varstore',
        vtpm: 'vTPM būsena',
        snapshots: 'Momentinės kopijos'
      },
      vmState: {
        stopped: 'VM išjungta',
        running: 'VM veikia (karštas)'
      },
      artifactClass: { metadata: 'Metaduomenys', data: 'Duomenys', secret: 'Paslaptis' },
      detail: {
        tabOverview: 'Apžvalga',
        tabArtefact: 'Artefaktas',
        id: 'Identifikatorius',
        scope: 'Sritis',
        vmState: 'VM būsena kopijuojant',
        pointInTime: 'Duomenų akimirka',
        completedAt: 'Baigta',
        node: 'Kopijavęs mazgas',
        error: 'Klaida',
        path: 'Katalogas saugykloje',
        checksum: 'manifesto sha256',
        secretsExposed: 'Jautri medžiaga atviru tekstu',
        secretsExposedYes: 'Taip — paskirties vieta nešifruoja',
        secretsExposedNo: 'Ne',
        baseBackup: 'Bazinė kopija',
        tabManifest: 'Manifestas',
        manifestHint:
          'Atviras artefakto rodyklė: viena byla eilutėje su savo sha256. Katalogą galima patikrinti ir be TVirt — pakanka qemu-img, tar ir jq.',
        manifestEmpty: 'Manifestas nenurodo bylų.',
        manifestError: 'Manifesto perskaityti nepavyksta',
        colEntry: 'Byla',
        colClass: 'Klasė',
        colSha: 'sha256'
      },
      create: {
        action: 'Kopijuoti dabar',
        title: 'Kopijuoti dabar',
        submit: 'Pradėti kopijavimą',
        destination: 'Paskirties vieta',
        destinationHint: 'Tik paskirties vietos, priimančios kopijas.',
        noDestinations: 'Nė viena paskirties vieta nepriima kopijų: sukurkite ją Sistema → Checkpoints.',
        contentsHint:
          'Keliauja visi diskai, UEFI varstore ir vTPM būsena. Pastarieji du yra esmė: užantspauduotas svečias turi vėl pasileisti.',
        error: 'Kopijavimas nepasileido',
        stillRunning: 'Kopijavimas dar vyksta — jis tęsiasi, net jei uždarysite.',
        vmRunning:
          'Mašina yra {phase}: atsarginei kopijai reikia nusistovėjusios VM — išjungtos šaltam kopijavimui, veikiančios karštam.'
      },
      restore: {
        action: 'Atkurti',
        title: 'Atkurti',
        intro: 'Atkūrimas negrįžtamas. Pasirinkite, kur grįžta duomenys: į naują mašiną ar ant pirminės.',
        modeNewVm: 'Atkurti į NAUJĄ VM',
        modeNewVmHint:
          'Neliečia nieko, kas egzistuoja — šia parinktimi kopija patikrinama. Naujas identifikatorius ir šviežiai nukalti MAC adresai.',
        modeOver: 'Perrašyti pirminę VM',
        modeOverHint: 'Sunaikina dabartinius tikslinės VM duomenis, be kelio atgal. Mašina turi būti išjungta.',
        newName: 'Naujos VM pavadinimas',
        newNameHint: 'Jis turi būti laisvas tikslinėje srityje.',
        storage: 'Saugykla diskams',
        storageHint: 'Privaloma: manifestas užrašo disko dydį ir formatą, bet niekada saugyklos, kurioje jis gulėjo.',
        metadataStorage: 'Saugykla varstore ir vTPM',
        metadataStorageHint: 'Kur nusileidžia UEFI tapatybė ir vTPM būsena.',
        sameAsStorage: 'Ta pati kaip diskų',
        bridge: 'Pagrindinio kompiuterio bridge',
        bridgeHint:
          'Kiekviena užrašyta tinklo plokštė grįžta į šį bridge su nauju MAC. Palikus tuščią, VM gimsta be plokščių — saugesnis numatytasis pasirinkimas.',
        overwriteTitle: 'Ketinate perrašyti šią VM',
        overwriteName: 'Pavadinimas',
        overwriteId: 'Identifikatorius',
        overwriteDisks: 'Diskai, kurie bus perrašyti',
        overwriteNoDisks: 'Diskų nėra.',
        overwriteKeeps:
          'Nepaliesti lieka identifikatorius, pavadinimas, sritis, tinklo plokštės ir MAC adresai: kopija yra DUOMENYS, konfigūracija yra checkpoint.',
        confirmField: 'VM pavadinimas',
        confirmHint: 'Įveskite {name}, kad patvirtintumėte.',
        targetLoading: 'Skaitoma tikslinė VM…',
        targetRunning: 'Tikslinė VM yra {phase}: atkūrimas perrašo baitus po svečiu, todėl reikalauja jos išjungtos.',
        targetGone: 'Pirminės VM nebegalima perskaityti: lieka atkūrimas į naują VM.',
        onlyComplete: 'Kopija yra {phase}: atkurti gali tik baigta kopija.',
        submitNewVm: 'Atkurti į naują VM',
        submitOver: 'Perrašyti',
        error: 'Atkūrimas nepasileido',
        stillRunning: 'Atkūrimas dar vyksta — ištisų diskų kopijavimas užtrunka.'
      }
    },
    guest: {
      title: {
        ct: 'Konteinerių duomenų atsarginės kopijos',
        app: 'App duomenų atsarginės kopijos'
      },
      tabTitle: 'Atsarginės kopijos',
      empty: 'Atsarginių kopijų nėra. Kopija perkelia nuolatinius duomenis į paskirtį ir pergyvena savo objektą.',
      colSubject: {
        ct: 'Konteineris',
        app: 'App'
      },
      colCreated: 'Sukurta',
      colPhase: 'Baigtis',
      colDestination: 'Paskirtis',
      colContains: 'Turinys',
      colSize: 'Dydis',
      colOrigin: 'Kilmė',
      policyRemoved: 'Policy pašalinta: {name}',
      policyRemovedHint:
        'Šį backup suplanavusi policy nebeegzistuoja: jokia retention jo nevaldo (niekada negenimas automatiškai) — ištrinkite jį rankiniu būdu, kai jo nebereikės.',
      phase: {
        running: 'Vykdoma',
        complete: 'Užbaigta',
        error: 'Nepavyko'
      },
      origin: {
        manual: 'Rankinė',
        schedule: 'Suplanuota'
      },
      state: {
        stopped: 'Objektas sustabdytas',
        running: 'Objektas veikia (užšaldytas)'
      },
      contains: {
        rootfs: 'Rootfs medis',
        config: 'Konfigūracija',
        volumes: 'Nuolatiniai tomai',
        root: 'Nuolatinis root'
      },
      artifactClass: {
        metadata: 'Metaduomenys',
        data: 'Duomenys',
        secret: 'Paslaptis'
      },
      create: {
        action: 'Kopijuoti dabar',
        title: 'Nauja atsarginė kopija',
        submit: 'Pradėti kopiją',
        error: 'Kopija nepasileido',
        destination: 'Paskirtis',
        destinationHint: 'Tik paskirtys, priimančios duomenų atsargines kopijas.',
        noDestinations:
          'Nė viena paskirtis nepriima duomenų atsarginių kopijų: pridėkite paskirčiai „Duomenų atsarginės kopijos“.',
        hint: {
          ct: 'Keliauja visas rootfs medis, ištikimai (skaitiniai savininkai, xattr, ACL), plius deklaruota konfigūracija manifeste. Veikiantis konteineris UŽŠALDOMAS visam pakavimui: crash-consistent kopija, deklaruota.',
          app: 'Keliauja TIK nuolatiniai tomai (ir nuolatinis root), plius konfigūracija manifeste. Efemeriška atmesta ratifikacija ir manifestas tai įvardija; slaptomis deklaruotos env reikšmės nekeliauja.'
        },
        stillRunning: 'Kopija dar vykdoma — pakuoti ištisus medžius užtrunka.'
      },
      detail: {
        tabOverview: 'Apžvalga',
        tabManifest: 'Manifestas',
        id: 'Identifikatorius',
        scope: 'Aprėptis',
        state: 'Būsena kopijavimo metu',
        pointInTime: 'Duomenys akimirkai',
        completedAt: 'Užbaigta',
        node: 'Kopijavęs mazgas',
        error: 'Klaida',
        path: 'Aplankas saugykloje',
        checksum: 'Manifesto sha256',
        manifestHint:
          'Artefakto rodyklė: po įrašą kiekvienam failui su jo sha256 — be maišų „kopija yra“ tėra tikėjimo aktas.',
        manifestError: 'Manifesto nepavyksta perskaityti',
        manifestEmpty: 'Manifeste artefaktų nėra.',
        colEntry: 'Failas',
        colClass: 'Klasė',
        colSha: 'sha256',
        excluded: 'Atmesta ratifikacija (nekeliauja)',
        secretKeys: 'Praleisti slapti env raktai (#307) — po atkūrimo įveskite iš naujo'
      },
      restore: {
        action: 'Atkurti',
        title: 'Atkūrimas',
        submit: 'Atkurti',
        error: 'Atkūrimas nepasileido',
        stillRunning: 'Atkūrimas dar vykdomas — išpakuoti ištisus medžius užtrunka.',
        onlyComplete: 'Kopija yra {phase}: atkurti gali tik užbaigta kopija.',
        asNew: {
          ct: 'Į NAUJĄ konteinerį — nieko nenaikina: gestas, kuriuo kopija patikrinama',
          app: 'Į NAUJĄ App — nieko nenaikina: gestas, kuriuo kopija patikrinama'
        },
        over: {
          ct: 'ANT šaltinio konteinerio — pakeičiamas visas rootfs medis',
          app: 'ANT šaltinio App — pakeičiamas kiekvieno nuolatinio tomo turinys'
        },
        name: 'Naujo objekto pavadinimas',
        storage: 'Saugykla',
        storageHint: 'Kur nusileidžia atkurti duomenys — manifestas niekada neužrašo prarasto pool.',
        storageDeclared: 'Manifeste deklaruotos saugyklos',
        bridge: 'Pagrindinio kompiuterio tiltas',
        bridgeHint:
          'Kiekviena užrašyta plokštė grįžta ant šio tilto su šviežiu MAC. Tuščia = gimsta neprijungtas, saugiausias numatytasis.',
        node: 'Mazgas',
        nodeHint: 'Narys, ant kurio App atgimsta: mazgas yra klasterio tapatybė ir niekada neateina iš manifesto.',
        secretKeysWarning:
          'Slaptomis deklaruotos env reikšmės kopijoje nekeliauja: atgimusi kopija nori jų įvestų iš naujo (task žurnalas įvardija raktus).',
        overInventory: 'Ketinate perrašyti šį objektą',
        confirmType: 'Patvirtinimui įveskite {name}',
        targetGone: 'Šaltinio objekto nebegalima perskaityti: lieka atkūrimas kaip naujo.',
        targetLoading: 'Skaitomas tikslinis objektas…',
        targetRunning: 'Tikslinis objektas veikia: atkūrimas pakeičia baitus po svečiu, todėl nori jo sustabdyto.'
      }
    }
  }
}
